import { render, staticRenderFns } from "./Wordpress.vue?vue&type=template&id=fe11eefe&scoped=true&"
import script from "./Wordpress.vue?vue&type=script&lang=js&"
export * from "./Wordpress.vue?vue&type=script&lang=js&"
import style1 from "./Wordpress.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe11eefe",
  null
  
)

export default component.exports